import { Col, Row, Typography } from "antd";
import { useJobRefine } from "hook/bailiff/job/action/useJobRefine";
import CardBailiffJob from "component/cards/job/card_bailiff_job";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffJob = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useJobRefine();

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    const valids = data?.length > 0;
    if (!valids) return null;
    return (
      <Row gutter={[20, 20]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Typography.Text style={{ fontSize: 18 }} type="secondary">
            file tạm thời
          </Typography.Text>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderLists()}
        </Col>
      </Row>
    );
  };

  const renderLists = () => {
    return (
      <Row gutter={[20, 20]}>
        {data?.map((item) => (
          <Col key={item?.id} xl={8} lg={8} md={8} xs={24}>
            <CardBailiffJob data={item} />
          </Col>
        ))}
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Row style={{ padding: "20px 0px" }} justify="center">
      <Col xl={14} lg={14} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};
export default BailiffJob;
